import SectionLabel from "@/components/base/SectionLabel";
import { dxAdvisoryData } from "@/mocks/dxAdvisoryData";

export default function FirstThreeMonthsSection() {
  return (
    <section className="py-16 md:py-22 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel label={dxAdvisoryData.firstThreeMonths.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {dxAdvisoryData.firstThreeMonths.title}
          </h2>
        </div>

        {/* Desktop: Horizontal compact timeline */}
        <div className="hidden lg:block">
          <div className="relative max-w-4xl mx-auto">
            {/* Horizontal line */}
            <div className="absolute top-[36px] left-[8%] right-[8%] h-px bg-background-300" />

            <div className="flex justify-between gap-8">
              {dxAdvisoryData.firstThreeMonths.months.map((m, idx) => (
                <div
                  key={m.month}
                  className="reveal relative flex flex-col items-center text-center flex-1"
                  style={{ transitionDelay: `${idx * 120}ms` }}
                >
                  {/* Dot */}
                  <div className="relative z-10 w-12 h-12 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-base font-bold font-heading mb-4">
                    {idx + 1}
                  </div>

                  {/* Month */}
                  <span className="text-xs font-medium tracking-wider text-primary-500 font-label mb-1">
                    {m.month}
                  </span>

                  {/* Purpose */}
                  <p className="text-sm font-bold text-foreground-900 mb-2 font-heading">
                    {m.purpose}
                  </p>

                  {/* Tasks */}
                  <p className="text-xs text-foreground-600 leading-relaxed mb-3 max-w-[200px]">
                    {m.tasks}
                  </p>

                  {/* Deliverables */}
                  <div className="mt-auto w-full rounded-md bg-primary-50/70 border border-primary-100/60 px-3 py-2.5">
                    <p className="text-[10px] text-foreground-600 font-label mb-0.5">成果物</p>
                    <p className="text-xs font-bold text-primary-700">{m.deliverables}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Mobile/Tablet: Vertical */}
        <div className="lg:hidden space-y-7 md:space-y-9">
          {dxAdvisoryData.firstThreeMonths.months.map((m, idx) => (
            <div
              key={m.month}
              className="reveal flex gap-4 md:gap-5 items-start"
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="flex flex-col items-center pt-1">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-sm font-bold font-heading flex-shrink-0">
                  {idx + 1}
                </div>
                {idx < dxAdvisoryData.firstThreeMonths.months.length - 1 && (
                  <div className="w-px flex-1 min-h-[50px] bg-background-300 mt-2" />
                )}
              </div>
              <div className="flex-1 pb-2">
                <span className="text-xs font-medium tracking-wider text-primary-500 font-label mb-1 block">
                  {m.month}
                </span>
                <p className="text-sm font-bold text-foreground-900 mb-1.5 font-heading">
                  {m.purpose}
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  {m.tasks}
                </p>
                <div className="rounded-md bg-primary-50/70 border border-primary-100/60 px-3 py-2">
                  <p className="text-xs text-foreground-600 font-label mb-0.5">成果物</p>
                  <p className="text-sm font-bold text-primary-700">{m.deliverables}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Note */}
        <p className="text-center text-xs md:text-sm text-foreground-500 mt-10 md:mt-12 reveal">
          {dxAdvisoryData.firstThreeMonths.note}
        </p>
      </div>
    </section>
  );
}